import React from "react";
import "../style.css";
import VideoPlayer from "../GalleryVideoPlayer";

interface GalleryShowcasedImageProps {
  selectedImage: string;
  video: string;
  videoSelected: boolean;
  bgColor?: string;  
  containerSize?: string;  
}

const Gallery__ShowcasedImage: React.FC<GalleryShowcasedImageProps> = ({
  selectedImage,
  video,
  videoSelected,
  bgColor = 'bg-gallerybackground',  
  containerSize = 'p-24',
}) => {
  return (
    <div
      className={`tw-flex tw-justify-center tw-rounded-xl tw-mt-8 md:tw-mt-0 tw-mb-4 md:tw-mb-8 tw-relative ln-image-container ${containerSize} ${bgColor}`}
    >
      
      {videoSelected ? (
        <VideoPlayer videoUrl={video} posterImg={selectedImage} />
      ) : (
        <img src={selectedImage} alt="showcased" />
      )}
    </div>
  );
};

export default Gallery__ShowcasedImage;
